import styled from 'styled-components';
import { DemoVehicleLabelStyled } from '../DemoVehicleLabelStyled';
import { rem } from 'polished';

export const DemoVehicleLabelStyledAC = styled(DemoVehicleLabelStyled)`
    .info {
        background: ${({ theme }) => theme.colors.blue2};
        border-radius: ${rem(8)};
        color: ${({ theme }) => theme.colors.white};
        font-size: ${({ theme }) => theme.fontSizes.h5};

        svg {
            g {
                circle,
                line {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }

    .details {
        color: ${({ theme }) => theme.colors.grey1};
        font-size: ${({ theme }) => theme.fontSizes.h5};

        &-label {
            color: ${({ theme }) => theme.colors.grey5};
        }
    }
`;
